import React from "react";
import { Link as GatsbyLink } from 'gatsby'
import {
  Box,
  Text,
  Center,
  Link
  } from '@chakra-ui/react'
import styled from '@emotion/styled';

const Icon = styled(Link)`
display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
    cursor: pointer;
    > p {
        color: #70A37F;
    }
    > div > svg {
        fill: #70A37F;
    }

    &:hover {
        > p {
            color: #40634A;
        }
        > div > svg {
            fill: #40634A;
        }
    }
`

const Calendar = (props) => {
  return (
    <Icon as={GatsbyLink} to="/events" _hover={{textDecoration: 'none'}}>
      <Center w="30%" mx="auto">
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 40.771 46.596">
    <path id="calendar-alt-solid" d="M0,42.227A4.369,4.369,0,0,0,4.368,46.6H36.4a4.369,4.369,0,0,0,4.368-4.368V17.473H0ZM29.122,24.39A1.1,1.1,0,0,1,30.214,23.3h3.64a1.1,1.1,0,0,1,1.092,1.092v3.64a1.1,1.1,0,0,1-1.092,1.092h-3.64a1.1,1.1,0,0,1-1.092-1.092Zm0,11.649a1.1,1.1,0,0,1,1.092-1.092h3.64a1.1,1.1,0,0,1,1.092,1.092v3.64a1.1,1.1,0,0,1-1.092,1.092h-3.64a1.1,1.1,0,0,1-1.092-1.092ZM17.473,24.39A1.1,1.1,0,0,1,18.565,23.3h3.64A1.1,1.1,0,0,1,23.3,24.39v3.64a1.1,1.1,0,0,1-1.092,1.092h-3.64a1.1,1.1,0,0,1-1.092-1.092Zm0,11.649a1.1,1.1,0,0,1,1.092-1.092h3.64A1.1,1.1,0,0,1,23.3,36.039v3.64a1.1,1.1,0,0,1-1.092,1.092h-3.64a1.1,1.1,0,0,1-1.092-1.092ZM5.824,24.39A1.1,1.1,0,0,1,6.917,23.3h3.64a1.1,1.1,0,0,1,1.092,1.092v3.64a1.1,1.1,0,0,1-1.092,1.092H6.917A1.1,1.1,0,0,1,5.824,28.03Zm0,11.649a1.1,1.1,0,0,1,1.092-1.092h3.64a1.1,1.1,0,0,1,1.092,1.092v3.64a1.1,1.1,0,0,1-1.092,1.092H6.917a1.1,1.1,0,0,1-1.092-1.092ZM36.4,5.824H32.035V1.456A1.46,1.46,0,0,0,30.578,0H27.666A1.46,1.46,0,0,0,26.21,1.456V5.824H14.561V1.456A1.46,1.46,0,0,0,13.105,0H10.193A1.46,1.46,0,0,0,8.737,1.456V5.824H4.368A4.369,4.369,0,0,0,0,10.193v4.368H40.771V10.193A4.369,4.369,0,0,0,36.4,5.824Z" />
  </svg>
   </Center>
   <Text textAlign="center" fontSize={{base: 'xs', md: 'sm'}} >
        Calendar
    </Text>
   </Icon>
  );
};

export default Calendar;